export default {
  hideCompletedEventList: 'Hide completed events',
};
